module.exports = __webpack_public_path__ + "media/a3.b4854f8c.wav";